import React, { useEffect } from "react"
import { useLocalState } from "src/settings/localStorage"

const DwContext = React.createContext({
    defaultGroupBy: '',
    groupBy: '',
    setGroupBy: (groupBy: string) => {},
    //groupableFields: [byFamilyMember, byPatentFamily, byProduct, byInvention],
    searchFields: [] as string[],
    setSearchFields: (searchFields: string[]) => {},
    sortOrder: 1,
    setSortOrder: (sortOrder: number) => {},
    sortField: '',
    setSortField: (sortField: string) => {},
    doOuterJoin: true,
    setDoOuterJoin: (doOuterJoin: boolean) => {},
})

export function useDwSettingsProvider() {
    return React.useContext(DwContext)
}

export function DwSettingsProvider({children, entity, defaultGroupBy, allowedValues}: {children: React.ReactNode, entity: string, defaultGroupBy: string, allowedValues: string[]}) {
    //console.log('recalculating RP')

    const [groupBy, setGroupBy] = useLocalState(entity + '-analytics-groupBy', defaultGroupBy as string)
    const [searchFields, setSearchFields] = useLocalState(entity + '-analytics-fields', [])
    const [sortOrder, setSortOrder] = useLocalState(entity + '-analytics-sort-order', +1)
    const [sortField, setSortField] = useLocalState(entity + '-analytics-sort-field', '')
    const [doOuterJoin, setDoOuterJoin] = useLocalState(entity + '-data-wizard-outer-join', true)

    useEffect(() => {
        if (allowedValues.indexOf(groupBy) < 0) {
            setGroupBy(defaultGroupBy)
        }
    }, [groupBy, setGroupBy, defaultGroupBy, allowedValues])

    const value = {
        //groupableFields,
        defaultGroupBy,
        groupBy, setGroupBy,
        searchFields, setSearchFields,
        sortOrder, setSortOrder,
        sortField, setSortField,
        doOuterJoin, setDoOuterJoin,
    }

    return (
        <DwContext.Provider {...{value}}>
            {children}
        </DwContext.Provider>
    )
}